/**
 * Application Configuration
 * 
 * This file centralizes all environment variables and configuration settings.
 * Instead of accessing process.env directly, import values from this file.
 */

interface AppConfig {
  api: {
    baseUrl: string;
  };
  features: {
    deleteAccount: boolean;
    turnstile: {
      enabled: boolean;
      siteKey: string;
    };
  };
  environment: {
    isDevelopment: boolean;
    isProduction: boolean;
    isTest: boolean;
  };
}

const config: AppConfig = {
  api: {
    baseUrl: process.env.REACT_APP_API_URL || 'https://expense-management.stg.rootopia.vn/api',
  },
  features: {
    deleteAccount: process.env.REACT_APP_ENABLE_DELETE_ACCOUNT === 'true',
    turnstile: {
      enabled: process.env.REACT_APP_IS_ENABLE_TURNSTILE === 'true',
      siteKey: process.env.REACT_APP_TURNSTILE_SITE_KEY || '',
    },
  },
  environment: {
    isDevelopment: process.env.NODE_ENV === 'development',
    isProduction: process.env.NODE_ENV === 'production',
    isTest: process.env.NODE_ENV === 'test',
  },
};

export default config;